import { CrownCapNames } from '../CrownCapNames';
import { CrownShape } from './CrownShape';
import { Orientation } from '@sick-davinci/glow';
// tslint:disable:no-any
const _shapeClasses = new Map();
/**
 * Decoration function for shapes which register for this cap
 * @param className The class name of the class which registers
 */
// tslint:disable-next-line: function-name
export function Shape(className) {
    return (target) => {
        _shapeClasses.set(className, target);
        return target;
    };
}
/**
 * Capability to add Solids (Crown Shape or Shape3D)
 */
export class CrownShapeCap {
    getName() {
        return CrownCapNames.CROWNSHAPE;
    }
    doClassToCapabilityMapping(map) {
        map.set(CrownShapeCap.className, CrownCapNames.CROWNSHAPE);
        map.set(CrownShapeCap.decoClassName, CrownCapNames.CROWNSHAPE);
    }
    // tslint:disable-next-line: no-any (must be any since it takes all kind of shapes)
    call(objectIn, sceneIn) {
        const { payload, materials } = objectIn;
        if (payload.Type === CrownShapeCap.className) {
            const deco = !!payload.Decorations && payload.Decorations.length === 1 ? payload.Decorations[0].data : undefined;
            const mat = !!materials && materials.length === 1 ? materials[0] : undefined;
            payload.Iconics.forEach((s) => {
                const className = s.class;
                if (_shapeClasses.has(className)) {
                    const shapeClazz = _shapeClasses.get(className);
                    const shapeInstance = new shapeClazz(s.data, deco, mat);
                    shapeInstance.children.forEach((si) => {
                        si.userData.imaginary = true; // disable touch-events for the outline: shape editor must always work on the main shape and not the outline
                    });
                    shapeInstance.name = objectIn.name;
                    shapeInstance.userData.format = () => format(shapeInstance, className);
                    Orientation.set(shapeInstance, objectIn);
                    sceneIn.addToParent(objectIn.parent || '', shapeInstance);
                    sceneIn.setTag(objectIn.tag, shapeInstance);
                }
            });
            return true;
        }
        return false;
    }
    update(objectIn, sceneIn) {
        const { payload: { Decoration, IconicId }, materials } = objectIn;
        if (Decoration.class === CrownShapeCap.decoClassName) {
            const mat = !!materials && materials.length === 1 ? materials[0] : undefined;
            const shape = sceneIn.getObjectByName(IconicId);
            if (shape != null && shape.children.length > 0) {
                shape.children[0].material = CrownShape.getLineMaterial(Decoration.data);
                shape.children[0].visible = Decoration.data.LineWidth > 0;
                let material = shape.material;
                // backup material settings which are set via ShapeCaps
                const depthWrite = material.depthWrite;
                const depthTest = material.depthTest;
                const side = material.side;
                // restore material settings
                material = CrownShape.getFillMaterial(mat, Decoration.data);
                material.side = side;
                material.depthTest = depthTest;
                material.depthWrite = depthWrite;
                shape.material = material;
                return true;
            }
        }
        return false;
    }
}
CrownShapeCap.className = 'SHAPE';
CrownShapeCap.decoClassName = 'View.ShapeDecoration';
/**
 * Bring the Object3D into the original format, so it is understood by the sender.
 * The basic structure is the same for all shapes. The data-structure is shape specific and has to
 * be implemented by each shape separately.
 * @param si
 * @param className
 */
function format(si, className) {
    return {
        class: className,
        data: si.format(),
    };
}
//# sourceMappingURL=CrownShapeCap.js.map